export default function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="relative overflow-hidden bg-surface py-6 md:py-8 border-y border-line">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-3xl md:text-5xl px-8 text-emerald">
              {item}
            </span>
            <span className="text-3xl md:text-5xl text-terracotta px-2">&bull;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
